export const NOW_LAMBDA_INFO = {
  api: "https://stv.spotvnow.co.kr",
  a_device: "https://dev-stv.spotvnow.co.kr:6060/d",
  a_view:
    "https://2qy1gtyzna.execute-api.ap-northeast-2.amazonaws.com/default/spotv_renewal_analytics",
  a_screen: "https://dev-stv.spotvnow.co.kr:6060/s",
  w_login: "wss://sock.spotvnow.co.kr:3030/",
  web: "https://www.spotvnow.co.kr",
  policyKey:
    "BCpkADawqM072_NUcqm8RBVoMGIaio2x979NvYhN4Zrs685jLKKYmCx_ssySm_0HFSnwPKQIbaekH1PnWGFk-nQCtuky-DlMgN4KNvNlPYjsojAi1fU9ozEXVSpULPylDb8STvOgPf-F941V-RbByAkzD8CgApyhBS8TNN-yDc17gnFUj82OEBP8DEo",
};

export const GOLF_LAMBDA_INFO = {
  api: "https://stv.spotvnowgolf.co.kr",
  a_view: "https://agl.spotvnowgolf.co.kr/default/spotv_renewal_analytics",
  w_login: "wss://sock.spotvnowgolf.co.kr:3030/",
  web: "https://www.spotvnowgolf.co.kr",
};

// 현대자동차 전석 해상도
export const HYUNDAI_WIDTH = 1280;

export const HYUNDAI_KEY_CODE = {
  PAUSE: [19, 413],
  PLAY: 415,
  FORWARD: 417,
  REWIND: 412,
};
